// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--11-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/dist/cjs.js??ref--11-2!../../node_modules/postcss-loader/src/index.js??ref--11-3!../../node_modules/sass-loader/dist/cjs.js??ref--11-4!./zopone.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("761330ed", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./scss/clients/zopone.scss
// module id = jcpp
// module chunks = 0